<div
  #container
  class="container"
  [style.padding.px]="containerPadding">
  <canvas
    class="canvas"
    [style.max-width.px]="canvasMaxWidth"
    #canvas
    style="touch-action: none " (drop)="drop($event)" (dragover)="allowDrop($event)">
  </canvas>
</div>
